export const topicGroups = {
  movies: ['english', 'harry_potter', 'marvel_cinematic_universe'],
  christmas: ['christmas_carols', 'movies', 'english'],
  christmas_carols: ['christmas', 'english', 'harry_potter'],
  harry_potter: ['movies', 'marvel_cinematic_universe', 'lord_of_the_rings'],
  warhammer_40k: ['movies', 'harry_potter', 'christmas'],
  english: ['movies', 'naruto', 'friends_sitcom'],
  friends_sitcom: ['movies', 'harry_potter', 'marvel_cinematic_universe'],
  naruto: ['movies', 'harry_potter', 'english'],
  cities: ['countries', 'english', 'movies'],
  countries: ['cities', 'movies', 'english'],
  football: ['baseball', 'basketball', 'golf'],
  marvel_cinematic_universe: ['movies', 'harry_potter', 'naruto'],
  game_of_thrones: ['lord_of_the_rings', 'marvel_cinematic_universe', 'harry_potter'],
  dota_2: ['warhammer_40k', 'football', 'movies'],
  rick_and_morty: ['harry_potter', 'marvel_cinematic_universe', 'movies'],
  south_park: ['rick_and_morty', 'marvel_cinematic_universe', 'movies'],
  code_geass: ['naruto', 'my_hero_academia', 'hunter_x_hunter'],
  my_hero_academia: ['naruto', 'hunter_x_hunter', 'code_geass'],
  hunter_x_hunter: ['naruto', 'my_hero_academia', 'code_geass'],
  jujutsu_kaisen: ['chainsaw_man', 'my_hero_academia', 'hunter_x_hunter'],
  disney: ['movies', 'marvel_cinematic_universe', 'harry_potter'],
  dimension_20: ['movies', 'english', 'stranger_things'],
  stranger_things: ['movies', 'game_of_thrones', 'harry_potter'],
  chemistry: ['science', 'physics', 'biology'],
  physics: ['science', 'chemistry', 'biology'],
  baseball: ['football', 'basketball', 'tennis'],
  basketball: ['football', 'baseball', 'tennis'],
  one_piece: ['dragon_ball', 'hunter_x_hunter', 'naruto'],
  attack_on_titan: ['naruto', 'one_piece', 'jujutsu_kaisen'],
  dragon_ball: ['naruto', 'one_piece', 'my_hero_academia'],
  person_of_interest: ['stranger_things', 'game_of_thrones', 'english'],
  demon_slayer: ['attack_on_titan', 'jujutsu_kaisen', 'my_hero_academia'],
  solo_leveling: ['hunter_x_hunter', 'attack_on_titan', 'jujutsu_kaisen'],
  breaking_bad: ['chemistry', 'person_of_interest', 'game_of_thrones'],
  spider_man: ['iron_man', 'batman', 'superman'],
  chainsaw_man: ['jujutsu_kaisen', 'demon_slayer', 'attack_on_titan'],
  invincible: ['superman', 'iron_man', 'batman'],
  death_note: ['code_geass', 'attack_on_titan', 'jujutsu_kaisen'],
  fullmetal_alchemist: ['attack_on_titan', 'demon_slayer', 'hunter_x_hunter'],
  science: ['chemistry', 'physics', 'biology'],
  valorant: ['dota_2', 'marvel_cinematic_universe', 'rick_and_morty'],
  minecraft: ['dragon_ball', 'naruto', 'marvel_cinematic_universe'],
  fortnite: ['valorant', 'minecraft', 'marvel_cinematic_universe'],
  mortal_kombat: ['marvel_cinematic_universe', 'game_of_thrones', 'dragon_ball'],
  the_legend_of_zelda: ['minecraft', 'fortnite', 'pokemon'],
  league_of_legends: ['valorant', 'dota_2', 'fortnite'],
  overwatch: ['valorant', 'league_of_legends', 'fortnite'],
  geography: ['countries', 'cities', 'science'],
  biology: ['chemistry', 'physics', 'science'],
  food: ['chemistry', 'geography', 'biology'],
  history: ['geography', 'science', 'countries'],
  sports: ['football', 'basketball', 'baseball'],
  animals: ['biology', 'dogs', 'food'],
  dogs: ['animals', 'biology', 'geography'],
  space: ['science', 'physics', 'geography'],
  historical_figures: ['history', 'geography', 'science'],
  golf: ['sports', 'geography', 'history'],
  tennis: ['sports', 'golf', 'football'],
  formula_1: ['sports', 'geography', 'history'],
  superhero: ['batman', 'spider_man', 'invincible'],
  batman: ['superhero', 'superman', 'dc'],
  star_wars: ['movies', 'science', 'space'],
  lord_of_the_rings: ['harry_potter', 'game_of_thrones', 'star_wars'],
  michael_jackson: ['star_wars', 'movies', 'historical_figures'],
  taylor_swift: ['christmas', 'disney', 'michael_jackson'],
  x_men: ['marvel_cinematic_universe', 'superhero', 'spider_man'],
  euphoria: ['breaking_bad', 'stranger_things', 'south_park'],
  severence: ['breaking_bad', 'person_of_interest', 'stranger_things'],
  house_of_the_dragon: ['game_of_thrones', 'lord_of_the_rings', 'stranger_things'],
  the_walking_dead: ['breaking_bad', 'stranger_things', 'game_of_thrones'],
  the_boys: ['invincible', 'breaking_bad', 'stranger_things'],
  the_last_of_us: ['breaking_bad', 'the_walking_dead', 'stranger_things'],
  wednesday: ['stranger_things', 'invincible', 'euphoria'],
  the_white_lotus: ['stranger_things', 'game_of_thrones', 'breaking_bad'],
  hacks: ['breaking_bad', 'friends_sitcom', 'rick_and_morty'],
  frieren: ['fullmetal_alchemist', 'attack_on_titan', 'demon_slayer'],
  one_punch_man: ['my_hero_academia', 'dragon_ball', 'demon_slayer'],
  dark: ['stranger_things', 'breaking_bad', 'person_of_interest'],
  assassination_classroom: ['my_hero_academia', 'hunter_x_hunter', 'demon_slayer'],
  supernatural: ['stranger_things', 'the_walking_dead', 'breaking_bad'],
  avengers: ['marvel_cinematic_universe', 'superhero', 'spider_man'],
  sopranos: ['breaking_bad', 'the_walking_dead', 'game_of_thrones'],
  the_wire: ['breaking_bad', 'sopranos', 'person_of_interest'],
  peaky_blinders: ['breaking_bad', 'the_wire', 'naruto'],
  dc: ['batman', 'superhero', 'marvel'],
  justice_league: ['dc', 'batman', 'superman'],
  magic_the_gathering: ['warhammer_40k', 'league_of_legends', 'dota_2'],
  the_simpsons: ['south_park', 'rick_and_morty', 'friends_sitcom'],
  he_man: ['star_wars', 'marvel_cinematic_universe', 'superhero'],
  big_bang_theory: ['friends_sitcom', 'the_simpsons', 'south_park'],
  frozen: ['disney', 'movies', 'christmas'],
  superman: ['batman', 'justice_league', 'dc'],
  iron_man: ['spider_man', 'avengers', 'marvel'],
  fantastic_four: ['marvel', 'avengers', 'marvel_cinematic_universe'],
  dhurandhar: ['breaking_bad', 'marvel_cinematic_universe', 'sopranos'],
  greys_anatomy: ['breaking_bad', 'the_boys', 'supernatural'],
  stormlight_archive: ['lord_of_the_rings', 'magic_the_gathering', 'game_of_thrones'],
  mistborn: ['lord_of_the_rings', 'stormlight_archive', 'harry_potter'],
  hunger_games: ['movies', 'dune', 'superhero'],
  dune: ['star_wars', 'lord_of_the_rings', 'science'],
  sonic: ["valorant", "minecraft", "league_of_legends"],
  family_guy: ["the_simpsons", "south_park", "rick_and_morty"],
  fairy_tail: ["naruto", "one_piece", "my_hero_academia"],
  tokyo_ghoul: ["attack_on_titan", "demon_slayer", "death_note"],
  berserk: ["attack_on_titan", "chainsaw_man", "fullmetal_alchemist"],
  music: ["taylor_swift", "michael_jackson", "movies"],
  boxing: ["sports", "formula_1", "tennis"],
  astronomy: ["biology", "science", "physics"],
  greek_mythology: ["history", "geography", "science"],
  pokemon: ["bluey", "hilda", "one_piece"],
  bleach: ["naruto", "one_piece", "dragon_ball"],
  black_clover: ["naruto", "demon_slayer", "jujutsu_kaisen"],
  dr_stone: ["demon_slayer", "jujutsu_kaisen", "one_punch_man"],
  bluey: ["disney", "hilda", "pokemon"],
  hilda: ["bluey", "pokemon", "disney"],
  arcane: ["league_of_legends", "invincible", "attack_on_titan"],
  castlevania: ["demon_slayer", "death_note", "berserk"],
  mr_inbetween: ["breaking_bad", "peaky_blinders", "sopranos"],
  doctor_who: ["stranger_things", "star_wars", "science"],
  bojack_horseman: ["rick_and_morty", "south_park", "big_bang_theory"],
  dungeons_and_dragons: ["warhammer_40k", "magic_the_gathering", "lord_of_the_rings"],
  beyblade: ["naruto", "pokemon", "frieren"],
  world_of_warcraft: ["league_of_legends", "overwatch", "dota_2"],
  ben_10: ["pokemon", "sonic", "gravity_falls"],
  military: ["warhammer_40k", "history", "geography"],
  ice_hockey: ["tennis", "football", "basketball"],
  gravity_falls: ["hilda", "bluey", "ben_10"],
  nfl: ["football", "sports", "baseball"],
  nba: ["basketball", "sports", "baseball"],
  clash_royale: ["league_of_legends", "dota_2", "valorant"],
  fallout: ["science", "history", "the_last_of_us"],
  call_of_duty: ["valorant", "overwatch", "fortnite"],
  danganronpa: ["assassination_classroom", "death_note", "my_hero_academia"],
  elden_ring: ["warhammer_40k", "league_of_legends", "minecraft"],
  resident_evil: ["the_last_of_us", "dark", "the_walking_dead"],
  monster_hunter: ["valorant", "overwatch", "league_of_legends"],
  skyrim: ["fallout", "elden_ring", "the_legend_of_zelda"],
  nhl: ["nfl", "nba", "ice_hockey"],
  rugby: ["football", "sports", "nfl"],
  psychology: ["biology", "science", "history"],
  persona: ["jujutsu_kaisen", "attack_on_titan", "demon_slayer"],
  dark_souls: ["elden_ring", "league_of_legends", "dungeons_and_dragons"],
  hades: ["elden_ring", "dark_souls", "skyrim"],
  hollow_knight: ["elden_ring", "dark_souls", "castlevania"],
  undertale: ["persona", "dark_souls", "hollow_knight"],
  deltarune: ["undertale", "persona", "terraria"],
  stardew_valley: ["minecraft", "pokemon", "dungeons_and_dragons"],
  balatro: ["dungeons_and_dragons", "elden_ring", "slay_the_spire"],
  slay_the_spire: ["hades", "dark_souls", "hollow_knight"],
  roblox: ["minecraft", "fortnite", "pokemon"],
  terraria: ["minecraft", "stardew_valley", "dungeons_and_dragons"],
  rust: ["minecraft", "fortnite", "call_of_duty"],
  animal_crossing: ["pokemon", "minecraft", "stardew_valley"],
  counter_strike: ["valorant", "call_of_duty", "overwatch"],
  halo: ["call_of_duty", "star_wars", "overwatch"],
  clash_of_clans: ["clash_royale", "minecraft", "fortnite"],
  brawl_stars: ["clash_royale", "clash_of_clans", "overwatch"],
  geometry_dash: ["minecraft", "terraria", "roblox"],
  lost: ["stranger_things", "the_walking_dead", "breaking_bad"],
  alien: ["movies", "science", "space"],
  transformers: ["marvel", "dc", "superhero"],
  percy_jackson: ["greek_mythology", "harry_potter", "hunger_games"],
  mlb: ["baseball", "nba", "nfl"],
  mma: ["boxing", "sports", "superhero"],
  wwe: ["sports", "superhero", "mortal_kombat"],
  cricket: ["baseball", "sports", "geography"],
  chess: ["history", "sports", "valorant"],
  poker: ["chess", "balatro", "sports"],
  lego: ["minecraft", "star_wars", "harry_potter"],
  yugioh: ["pokemon", "magic_the_gathering", "balatro"],
  philosophy: ["psychology", "history", "greek_mythology"],
  periodic_table: ["chemistry", "physics", "science"],
  birds: ["animals", "biology", "geography"],
  geology: ["chemistry", "physics", "astronomy"],
  tiktok: ["music", "taylor_swift", "michael_jackson"],
  hip_hop: ["music", "michael_jackson", "taylor_swift"],
  the_witcher: ["game_of_thrones", "lord_of_the_rings", "dungeons_and_dragons"],
  cyberpunk_2077: ["the_witcher", "fallout", "elden_ring"],
  slam_dunk: ["basketball", "sports", "dragon_ball"],
  sailor_moon: ["attack_on_titan", "my_hero_academia", "naruto"],
  yu_yu_hakusho: ["hunter_x_hunter", "bleach", "dragon_ball"],
  blue_lock: ["football", "sports", "slam_dunk"],
  re_zero: ["attack_on_titan", "demon_slayer", "jujutsu_kaisen"],
  mushoku_tensei: ["re_zero", "solo_leveling", "frieren"],
  that_time_i_got_reincarnated_as_a_slime: ["one_piece", "naruto", "frieren"],
  overlord: ["that_time_i_got_reincarnated_as_a_slime", "re_zero", "mushoku_tensei"],
  made_in_abyss: ["attack_on_titan", "fullmetal_alchemist", "hunter_x_hunter"],
  erased: ["death_note", "attack_on_titan", "tokyo_ghoul"],
  gta: ["the_witcher", "call_of_duty", "cyberpunk_2077"],
  red_dead_redemption: ["gta", "the_witcher", "the_last_of_us"],
  god_of_war: ["greek_mythology", "marvel_cinematic_universe", "the_legend_of_zelda"],
  silent_hill: ["resident_evil", "dark_souls", "persona"],
  tomb_raider: ["resident_evil", "the_legend_of_zelda", "uncharted"],
  uncharted: ["the_last_of_us", "tomb_raider", "valorant"],
  metal_gear_solid: ["resident_evil", "silent_hill", "the_last_of_us"],
  elder_scrolls: ["fallout", "the_witcher", "dragon_ball"],
  sekiro: ["dark_souls", "elden_ring", "hollow_knight"],
  cuphead: ["hollow_knight", "undertale", "deltarune"],
  omori: ["undertale", "deltarune", "sekiro"],
  pubg: ["fortnite", "call_of_duty", "valorant"],
  palworld: ["pokemon", "the_legend_of_zelda", "minecraft"],
  super_mario: ["sonic", "the_legend_of_zelda", "pokemon"],
  kirby: ["pokemon", "super_mario", "the_legend_of_zelda"],
  donkey_kong: ["super_mario", "sonic", "kirby"],
  splatoon: ["pokemon", "super_mario", "kirby"],
  crash_bandicoot: ["sonic", "super_mario", "donkey_kong"],
  genshin_impact: ["league_of_legends", "dota_2", "arcane"],
  honkai_star_rail: ["genshin_impact", "persona", "omori"],
  zenless_zone_zero: ["genshin_impact", "honkai_star_rail", "crash_bandicoot"],
  blue_archive: ["genshin_impact", "honkai_star_rail", "persona"],
  street_fighter: ["mortal_kombat", "marvel", "dc"],
  tekken: ["street_fighter", "mortal_kombat", "kirby"],
  guilty_gear: ["street_fighter", "tekken", "mortal_kombat"],
  rainbow_six_siege: ["call_of_duty", "counter_strike", "valorant"],
  rocket_league: ["overwatch", "fortnite", "call_of_duty"],
  destiny_2: ["halo", "overwatch", "call_of_duty"],
  runescape: ["world_of_warcraft", "minecraft", "the_legend_of_zelda"],
  subnautica: ["terraria", "minecraft", "stardew_valley"],
  dead_by_daylight: ["overwatch", "resident_evil", "halo"],
  black_desert: ["world_of_warcraft", "elden_ring", "dota_2"],
  succession: ["peaky_blinders", "the_wire", "sopranos"],
  star_trek: ["science", "space", "star_wars"],
  iron_maiden: ["music", "michael_jackson", "taylor_swift"],
  kingdom_hearts: ["disney", "honkai_star_rail", "zenless_zone_zero"],
  the_office: ["friends_sitcom", "community", "big_bang_theory"],
  community: ["the_office", "friends_sitcom", "rick_and_morty"],
  alice_in_borderland: ["death_note", "danganronpa", "hunter_x_hunter"],
  outlander: ["history", "historical_figures", "harry_potter"],
  gilmore_girls: ["friends_sitcom", "greys_anatomy", "the_office"],
  avatar_the_last_airbender: ["naruto", "my_hero_academia", "hunter_x_hunter"],
  phineas_and_ferb: ["disney", "gravity_falls", "bluey"],
  steven_universe: ["avatar_the_last_airbender", "gravity_falls", "rick_and_morty"],
  teen_titans: ["dc", "justice_league", "batman"],
  human_anatomy: ["biology", "science", "chemistry"],
  insects: ["animals", "biology", "science"],
  king_of_the_hill: ["the_simpsons", "family_guy", "south_park"],
  archer: ["rick_and_morty", "south_park", "family_guy"],
  indiana_jones: ["star_wars", "star_trek", "rick_and_morty"],
  twilight: ["harry_potter", "hunger_games", "percy_jackson"],
  barbie: ["disney", "frozen", "music"],
  studio_ghibli: ["disney", "movies", "marvel"],
  pixar: ["disney", "frozen", "movies"],
  shrek: ["disney", "fairy_tail", "frozen"],
  how_to_train_your_dragon: ["disney", "frozen", "shrek"],
  ariana_grande: ["taylor_swift", "music", "michael_jackson"],
  dinosaurs: ["science", "animals", "geology"],
  us_geography: ["geography", "countries", "cities"],
};

export const topicLengths = {
  attack_on_titan: 49,
  baseball: 50,
  basketball: 46,
  chemistry: 48,
  christmas: 74,
  christmas_carols: 46,
  cities: 50,
  countries: 65,
  code_geass: 28,
  disney: 122,
  dota_2: 172,
  dimension_20: 32,
  dragon_ball: 50,
  english: 2315,
  football: 57,
  friends_sitcom: 111,
  game_of_thrones: 176,
  harry_potter: 77,
  hunter_x_hunter: 52,
  jujutsu_kaisen: 32,
  marvel_cinematic_universe: 201,
  movies: 132,
  my_hero_academia: 55,
  naruto: 108,
  one_piece: 80,
  person_of_interest: 62,
  physics: 34,
  rick_and_morty: 77,
  south_park: 85,
  stranger_things: 35,
  warhammer_40k: 79,
  demon_slayer: 50,
  solo_leveling: 80,
  breaking_bad: 39,
  spider_man: 28,
  chainsaw_man: 33,
  invincible: 25,
  death_note: 44,
  fullmetal_alchemist: 63,
  science: 177,
  valorant: 58,
  minecraft: 232,
  fortnite: 17,
  mortal_kombat: 59,
  the_legend_of_zelda: 124,
  league_of_legends: 35,
  overwatch: 55,
  geography: 71,
  biology: 64,
  food: 136,
  history: 181,
  sports: 22,
  animals: 117,
  dogs: 17,
  space: 74,
  historical_figures: 74,
  golf: 42,
  tennis: 34,
  formula_1: 46,
  superhero: 26,
  batman: 42,
  star_wars: 184,
  lord_of_the_rings: 92,
  michael_jackson: 91,
  taylor_swift: 124,
  x_men: 74,
  euphoria: 19,
  severence: 12,
  house_of_the_dragon: 91,
  the_walking_dead: 126,
  the_boys: 35,
  the_last_of_us: 28,
  wednesday: 16,
  the_white_lotus: 12,
  hacks: 9,
  frieren: 40,
  one_punch_man: 38,
  dark: 26,
  assassination_classroom: 42,
  supernatural: 40,
  avengers: 112,
  sopranos: 23,
  the_wire: 39,
  dc: 260,
  marvel: 140,
  justice_league: 214,
  magic_the_gathering: 200,
  the_simpsons: 91,
  he_man: 40,
  big_bang_theory: 25,
  frozen: 18,
  superman: 28,
  iron_man: 19,
  fantastic_four: 49,
  dhurandhar: 39,
  greys_anatomy: 33,
  stormlight_archive: 73,
  mistborn: 37,
  hunger_games: 46,
  dune: 52,
  astronomy: 113,
  berserk: 43,
  boxing: 81,
  fairy_tail: 175,
  family_guy: 30,
  greek_mythology: 70,
  music: 101,
  peaky_blinders: 9,
  sonic: 166,
  tokyo_ghoul: 64,
  arcane: 17,
  black_clover: 76,
  bleach: 123,
  bluey: 46,
  castlevania: 85,
  doctor_who: 210,
  dr_stone: 27,
  hilda: 32,
  mr_inbetween: 9,
  pokemon: 131,
  the_dragon_prince: 51,
  bojack_horseman: 18,
  dungeons_and_dragons: 132,
  beyblade: 101,
  world_of_warcraft: 478,
  ben_10: 52,
  military: 144,
  ice_hockey: 91,
  gravity_falls: 37,
  nfl: 112,
  nba: 96,
  clash_royale: 36,
  fallout: 285,
  call_of_duty: 318,
  danganronpa: 43,
  elden_ring: 185,
  resident_evil: 131,
  monster_hunter: 61,
  skyrim: 261,
  nhl: 121,
  rugby: 83,
  psychology: 126,
  persona: 213,
  dark_souls: 92,
  hades: 38,
  hollow_knight: 57,
  undertale: 41,
  deltarune: 51,
  stardew_valley: 125,
  balatro: 8,
  slay_the_spire: 32,
  roblox: 44,
  terraria: 171,
  rust: 42,
  animal_crossing: 206,
  counter_strike: 48,
  halo: 116,
  clash_of_clans: 39,
  brawl_stars: 82,
  geometry_dash: 17,
  lost: 131,
  alien: 43,
  transformers: 80,
  percy_jackson: 145,
  mlb: 60,
  mma: 116,
  wwe: 167,
  cricket: 52,
  chess: 67,
  poker: 94,
  lego: 191,
  yugioh: 289,
  philosophy: 65,
  periodic_table: 43,
  birds: 103,
  geology: 144,
  tiktok: 56,
  hip_hop: 138,
  the_witcher: 108,
  cyberpunk_2077: 47,
  slam_dunk: 19,
  sailor_moon: 41,
  yu_yu_hakusho: 53,
  blue_lock: 44,
  re_zero: 27,
  mushoku_tensei: 33,
  that_time_i_got_reincarnated_as_a_slime: 91,
  overlord: 54,
  made_in_abyss: 24,
  erased: 9,
  gta: 343,
  red_dead_redemption: 80,
  god_of_war: 85,
  silent_hill: 36,
  tomb_raider: 54,
  uncharted: 33,
  metal_gear_solid: 83,
  elder_scrolls: 26,
  sekiro: 60,
  cuphead: 19,
  omori: 44,
  pubg: 21,
  palworld: 24,
  super_mario: 137,
  kirby: 131,
  donkey_kong: 74,
  splatoon: 42,
  crash_bandicoot: 55,
  genshin_impact: 188,
  honkai_star_rail: 78,
  zenless_zone_zero: 51,
  blue_archive: 43,
  street_fighter: 92,
  tekken: 77,
  guilty_gear: 46,
  rainbow_six_siege: 71,
  rocket_league: 36,
  destiny_2: 209,
  runescape: 292,
  subnautica: 65,
  dead_by_daylight: 63,
  black_desert: 40,
  succession: 16,
  star_trek: 238,
  iron_maiden: 84,
  kingdom_hearts: 154,
  the_office: 39,
  community: 33,
  alice_in_borderland: 24,
  outlander: 18,
  gilmore_girls: 35,
  avatar_the_last_airbender: 72,
  phineas_and_ferb: 42,
  steven_universe: 52,
  teen_titans: 38,
  human_anatomy: 101,
  insects: 24,
  king_of_the_hill: 27,
  archer: 24,
  indiana_jones: 59,
  twilight: 64,
  barbie: 15,
  studio_ghibli: 48,
  pixar: 108,
  shrek: 28,
  how_to_train_your_dragon: 37,
  ariana_grande: 64,
  dinosaurs: 72,
  us_geography: 96,
}

// Only entries where toTitleCase() produces an incorrect result
export const displayNames = {
  warhammer_40k: 'Warhammer 40K',
  rick_and_morty: 'Rick and Morty',
  friends_sitcom: 'Friends',
  person_of_interest: 'Person of Interest',
  game_of_thrones: 'Game of Thrones',
  spider_man: 'Spider-Man',
  x_men: 'X-Men',
  he_man: 'He-Man',
  dc: 'DC',
  magic_the_gathering: 'Magic: The Gathering',
  greys_anatomy: "Grey's Anatomy",
  severence: 'Severance',
  nfl: 'NFL',
  nba: 'NBA',
  nhl: 'NHL',
  call_of_duty: 'Call of Duty',
  mlb: 'MLB',
  mma: 'MMA',
  wwe: 'WWE',
  gta: 'GTA',
  re_zero: 'Re:Zero',
  pubg: 'PUBG',
  king_of_the_hill: 'King of the Hill',
  us_geography: 'US Geography'
};
